import {DateTime} from "luxon";
import {queryClient} from "./query-client";
import ngage from "./ngage";

// Constants
export const PER_PAGE_DAY = 120;
export const PER_PAGE_WEEK = 700;
export const PER_PAGE_MONTH = 3500;

export function prefetchEventsBetween(startDate: DateTime, endDate: DateTime, perPage: number, siteId: number | null, typeId: number | null) {
  queryClient.prefetchQuery(
    ['events.between', {start: startDate.toISODate(), end: endDate.toISODate(), siteId, typeId}],
    async ({signal}) => ngage.events.between(startDate, endDate, 1, perPage, siteId, typeId, {signal})
  ).catch()
}

export function prefetchNearbyDays(selectedDate: DateTime, siteId: number | null) {
  const previousDayStart = selectedDate.minus({day: 1}).startOf('day')
  const previousDayEnd = previousDayStart.endOf('day')
  prefetchEventsBetween(previousDayStart, previousDayEnd, PER_PAGE_DAY, siteId, null)

  const nextDayStart = selectedDate.plus({day: 1}).startOf('day')
  const nextDayEnd = nextDayStart.endOf('day')
  prefetchEventsBetween(nextDayStart, nextDayEnd, PER_PAGE_DAY, siteId, null)
}

export function prefetchNearbyWeeks(selectedDate: DateTime, siteId: number | null) {
  const previousWeekStart = selectedDate.minus({week: 1}).startOf('week')
  const previousWeekEnd = previousWeekStart.endOf('week')
  prefetchEventsBetween(previousWeekStart, previousWeekEnd, PER_PAGE_WEEK, siteId, null)

  const nextWeekStart = selectedDate.plus({week: 1}).startOf('week')
  const nextWeekEnd = nextWeekStart.endOf('week')
  prefetchEventsBetween(nextWeekStart, nextWeekEnd, PER_PAGE_WEEK, siteId, null)
}

export function prefetchNearbyMonths(selectedDate: DateTime, siteId: number | null) {
  const previousMonthStart = selectedDate.minus({month: 1}).startOf('month').startOf('week')
  const previousMonthEnd = selectedDate.minus({month: 1}).endOf('month').endOf('week')
  prefetchEventsBetween(previousMonthStart, previousMonthEnd, PER_PAGE_MONTH, siteId, null)

  const nextMonthStart = selectedDate.plus({month: 1}).startOf('month').startOf('week')
  const nextMonthEnd = selectedDate.plus({month: 1}).endOf('month').endOf('week')
  prefetchEventsBetween(nextMonthStart, nextMonthEnd, PER_PAGE_MONTH, siteId, null)
}

